import axios from "axios";
import { getApiBase } from "./apiBase";

export type ResolvedGameScreen = {
  url: string;
  name: string;
};

function pickUrl(payload: any): string {
  return String(payload?.screenUrl ?? payload?.data?.screenUrl ?? "").trim();
}

export async function resolveGameScreenLink(
  gameIds: Array<string | undefined | null>
): Promise<ResolvedGameScreen> {
  for (const gameId of gameIds) {
    const key = String(gameId ?? "").trim();
    if (!key) continue;
    try {
      const res = await axios.get(
        `${getApiBase()}/game-screen-links/resolve/${encodeURIComponent(key)}`
      );
      const payload = res.data;
      const url = pickUrl(payload);
      if (url && payload?.source !== "empty") {
        return {
          url,
          name: String(payload?.gameName || payload?.data?.gameName || "GG88"),
        };
      }
    } catch {
      // thử key tiếp theo
    }
  }
  return { url: "", name: "GG88" };
}
